import api from '@/services/api';
const ENTITY_ENDPOINT = 'material-categoria';

export class MaterialCategoriaService {
  /**
   * Obtiene todas las categorías de materiales
   * @param {Object} params - Parámetros de filtrado y paginación
   * @returns {Promise<Object>} Respuesta de la API
   */
  static async findAll(params = {}) {
    return await api.get(`/${ENTITY_ENDPOINT}`, { params });
  }

  /**
   * Obtiene una categoría de material por su código
   * @param {string|number} codigo - Código de la categoría
   * @returns {Promise<Object>} Respuesta de la API
   */
  static async findByCode(codigo) {
    return await api.get(`/${ENTITY_ENDPOINT}/${codigo}`);
  }

  /**
   * Obtiene categorías activas únicamente
   * @returns {Promise<Object>} Respuesta de la API con categorías activas
   */
  static async findActive() {
    return await api.get(`/${ENTITY_ENDPOINT}`, {
      params: {
        activo: true,
      },
    });
  }

  /**
   * Obtiene categorías con materiales asociados
   * @param {Object} params - Parámetros adicionales
   * @returns {Promise<Object>} Respuesta de la API
   */
  static async findWithMaterials(params = {}) {
    return await api.get(`/${ENTITY_ENDPOINT}/with-materials`, { params });
  }

  /**
   * Obtiene los materiales de una categoría específica
   * @param {string|number} codigoCategoria - Código de la categoría
   * @param {Object} params - Parámetros adicionales (página, límite, filtros)
   * @returns {Promise<Object>} Respuesta de la API con materiales de la categoría
   */
  static async getMaterialesByCategoria(codigoCategoria, params = {}) {
    return await api.get(`/${ENTITY_ENDPOINT}/${codigoCategoria}/materiales`, { params });
  }

  /**
   * Busca materiales dentro de una categoría específica
   * @param {string|number} codigoCategoria - Código de la categoría
   * @param {string} query - Término de búsqueda
   * @param {Object} params - Parámetros adicionales
   * @returns {Promise<Object>} Respuesta de la API
   */
  static async searchMaterialesInCategoria(codigoCategoria, query, params = {}) {
    return await api.get(`/${ENTITY_ENDPOINT}/${codigoCategoria}/materiales/search`, {
      params: {
        descripcion: query,
        ...params,
      },
    });
  }
}

export default MaterialCategoriaService;
